// NOTAS index
// Esta es la pagina de inicio del programa

// css
import './index.css';

//inclui estas 3 linea para estilizar el nabvar
import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';

// Interface del usuario (GUI)
import 'mdbreact/dist/css/mdb.css';
import 'font-awesome/css/font-awesome.min.css';

// Paginas
import Contactenos from './paginas/Contactenos'
import Inicio from './paginas/Inicio'
import Layout from './layout/Layout'
import Servicios from './paginas/Servicios'
import Equipo from './paginas/Equipo'
import RegenciaQuimicaInfo from './paginas/RegenciaQuimicaInfo'
import RegenciaQuimicaCotizacion from './paginas/RegenciaQuimicaCotizacion'

// React 
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

// Routing react-router-dom
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import * as rutas from './rutas/rutas'
import Tarjeta from './paginas/CascadingCard';

// utilitarios


class App extends Component {

  // constructor(props) {
  //   super(props)
  // } //fin de constructor

  componentDidMount() {
  } //fin componentDidMount

  render () {
    return (
      <div className='body-bg'>
        <Switch>
          <Route path= {rutas.CONTACTENOS} component={Contactenos} />
          <Route path= {rutas.INICIO} component={Inicio} />
          <Route path= {rutas.QUIENES_SOMOS} component={Equipo} />
          <Route path= {rutas.SERVICIOS} component={Servicios} />
          <Route path= {rutas.REGENCIA_QUIMICA_INFO} component={RegenciaQuimicaInfo} />
          <Route path= {rutas.REGENCIA_QUIMICA_COTIZACION} component={RegenciaQuimicaCotizacion} />

          {/* <Route path= {rutas.LANDING} component={Landing} /> */}
        </Switch>
      </div>
    )
  } //finrender

} //fin class App


ReactDOM.render(
  <BrowserRouter>
    <Layout>
      <App/>
    </Layout>
  </BrowserRouter>
,document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js